import { BallTriangle } from "react-loader-spinner";
import PropTypes from "prop-types";
import colors from "assets/theme/base/colors";
import MDBox from "components/MDBox";

const Loader = () => {
  const { sideNav } = colors;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "0",
        bottom: "0",
        height: "100vh",
        width: "100%",
        paddingLeft: 0,
        backgroundColor: `${sideNav.hover}`,
        zIndex: 9999,
      }}
    >
      <BallTriangle
        height={100}
        width={100}
        radius={4}
        color={sideNav.hoverTextColor}
        ariaLabel="ball-triangle-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
      <MDBox
        color={sideNav.textColor}
        sx={{ textWrap: "nowrap", marginTop: "20px", fontWeight: "500", fontSize: "18px" }}
      >
        Loading...
      </MDBox>
    </div>
  );
};
Loader.propTypes = {
  width: PropTypes.string,
};

export default Loader;
